export default "__VITE_ASSET__CaCaMEki__"